var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 18.9375C34.375 11.25 27.625 6 20 6C12.3125 6 5.5625 11.25 2.1875 18.9375C2.0625 19.25 2 19.6875 2 20C2 20.3125 2.0625 20.8125 2.1875 21.125C5.5625 28.8125 12.3125 34 20 34C27.625 34 34.375 28.8125 37.75 21.125C37.875 20.8125 38 20.3125 38 20C38 19.6875 37.875 19.25 37.75 18.9375ZM20 31C13.75 31 8 26.8125 5 20.0625C8.0625 13.25 13.75 9 20 9C26.1875 9 31.9375 13.25 34.9375 20C31.875 26.8125 26.1875 31 20 31ZM20 12C15.5625 12 12 15.625 12 20C12 24.4375 15.5625 28 20 28C24.375 28 28 24.4375 28 20.0625C28 15.625 24.375 12 20 12ZM20 25C17.1875 25 15 22.8125 15 20C15 20 15 19.9375 15 19.875C15.3125 20 15.625 20 16 20C18.1875 20 20 18.25 20 16C20 15.6875 19.9375 15.375 19.8125 15.0625C19.875 15.0625 19.9375 15 20 15C22.75 15 25 17.25 25 20.0625C25 22.8125 22.75 25 20 25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c618674178ceaa84025a338c374c51da.svg";
export { ForwardRef as ReactComponent };